
import { Component, Emit, Vue ,Prop} from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppCesium";
import { IMapApp } from "@/types/cesiumMap";

@Component({
  name: "MapContainerCesium",
})
export default class MapContainerCesium extends Vue implements IMapApp {
  // private mapConfig!: Object;
  @Prop({ type: Object }) readonly mapConfig!: any;

  private mapApp!: MapApp;

  private mapClickEvent!: any;
  private markerClickEvent!: any;
  private markerMouseEvent!: any;

  async mounted() {
    this.mapApp = new MapApp();
    this.mapApp.mapClick = this.mapClick;
    this.mapApp.markerClick = this.markerClick;
    this.mapApp.markerMouseMove = this.markerMouse;
    this.mapApp.markerMouseIn = this.makerMouseIn;
    this.mapApp.markerMouseOut = this.markerMouseOut;
    await this.mapApp.init("divCMap", this.mapConfig);
    this.mapLoaded();
  }

  //自定义地图加载事件
  @Emit("map-loaded")
  private mapLoaded() {
    //do nothing
  }

  @Emit("map-click")
  private mapClick(event: any) {
    //do nothing
    this.mapClickEvent = event;
  }

  @Emit("marker-click")
  private markerClick(event: any) {
    //do something
    this.markerClickEvent = event;
  }

  @Emit("marker-mouse")
  private markerMouse(event: any) {
    //do something
    this.markerMouseEvent = event;
  }

  @Emit("marker-mouseIn")
  private makerMouseIn(event: any) {
    //do something
    this.markerMouseEvent = event;
  }

  @Emit("marker-mouseOut")
  private markerMouseOut(event: any) {
    //do something
    this.markerMouseEvent = event;
  }

  //
  public async setMapCenterAndLevel(params: any): Promise<any> {
    return this.mapApp.setMapCenterAndLevel(params);
  }
  
  public async startDrawOverlays(params: any): Promise<any> {
    return this.mapApp.startDrawOverlays(params);
  }
  // public async stopDrawOverlays(): Promise<any> {
  //   return this.mapApp.stopDrawOverlays();
  // }
  public async deleteDrawOverlays(params: any): Promise<any> {
    return this.mapApp.deleteDrawOverlays(params);
  }
  public async addOverlays(params: any): Promise<any> {
    return this.mapApp.addOverlays(params);
  }
  public async deleteOverlays(params: any): Promise<any> {
    return this.mapApp.deleteOverlays(params);
  }
  // //
  // public async loadDriveModel(params: any): Promise<any> {
  //   return this.mapApp.loadDriveModel(params);
  // }
  // public changeDriveStatus(params: any): void {
  //   return this.mapApp.changeDriveStatus(params);
  // }
  // public removeDriveModel(params: any): any {
  //   return this.mapApp.removeDriveModel(params);
  // }
  // public focusDriveModel(params: any): any {
  //   return this.mapApp.focusDriveModel(params);
  // }
  // public cancelFocusDriveModel(): void {
  //   return this.mapApp.cancelFocusDriveModel();
  // }
  // //
  // public loadRouteDriveModel(p: any): Promise<any> {
  //   return this.mapApp.loadRouteDriveModel(p);
  // }
  // public removeRouteDriveModel(p: any): void {
  //   return this.mapApp.removeRouteDriveModel(p);
  // }
  // public focusRouteDrive(p: any): void {
  //   return this.mapApp.focusRouteDrive(p);
  // }
  // public cancelFocusRouteDrive(): void {
  //   return this.mapApp.cancelFocusRouteDrive();
  // }
  // public driveOnRoute(params: any): any {
  //   return this.mapApp.driveOnRoute(params);
  // }
  // //
  // public load3Dtiles(params: any): any {
  //   return this.mapApp.load3Dtiles(params);
  // }
  // public loadGLTF(params: any): any {
  //   return this.mapApp.loadGLTF(params);
  // }
  // public remove3Dtiles(params: any): void {
  //   return this.mapApp.remove3Dtiles(params);
  // }
  // public removeGLTF(params: any): void {
  //   return this.mapApp.removeGLTF(params);
  // }
}
